export default {
  "commerce-sector-G1":	"Alimentación",
  "commerce-sector-G2":	"Gasolineras",
  "commerce-sector-G3":	"Hoteles & Viajes", 
  "commerce-sector-G4":	"Restauración",
  "commerce-sector-G5":	"Ropa",
  "commerce-sector-G6":	"Bricolaje & Hogar", 
  "commerce-sector-G7":	"Salud",
  "commerce-sector-G8":	"Transporte",
  "commerce-sector-G9":	"Otros comercios",
  "commerce-sector-total":	"Todos los sectores",
  "commerce-sector-total-sectors":	"Todos los sectores",
}